export default __webpack_public_path__ + "static/media/superwarm_v_top.b983f7b1.jpg";